import * as yup from "yup";
import { LocalizationService } from "@progress/kendo-react-intl";
import { enMessages } from "../../../messages/en-US";

interface ValidationParams {
  reservoirNames: string[];
  localizationService: LocalizationService;
  currentName?: string;
}

export default function ReservoirValidationSchema({ reservoirNames, localizationService, currentName }: ValidationParams) {
  return yup.object().shape({
    name: yup
      .string()
      .min(2)
      .max(150)
      .required(localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired))
      .test(
        'unique-name',
        localizationService.toLanguageString('custom.reservoirNameExists', enMessages.custom.uniqueName),
        function(value) {
          if (!value) return true;
          
          // Check current name
          if (currentName && value.toLowerCase() === currentName.toLowerCase()) {
            return true;
          }

          // Check for duplicates
          return !reservoirNames.some(
            existingName => existingName.toLowerCase() === value.toLowerCase()
          );
        }
      ),
    description: yup
      .string()
      .max(400),
    capacity: yup
      .number()
      .moreThan(0)
      .required(localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired)),
    consumable: yup
      .object()
      .nullable()
      .required(localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired))
  });
}